module.exports = __webpack_public_path__ + "static/4-74f440ecaa61246b6520bc5f8fe19c45.png";